import { ArrowRight, Menu, X, Phone } from "lucide-react";
import { COMPANY } from "@/i18n";
import LangSwitcher from "@/components/sections/header/LangSwitcher";
import MobileLangSwitcher from "@/components/sections/header/MobileLangSwitcher";

export default function HeaderActions({ t, lang, setLang, onBook, menuOpen, toggleMenu }) {
  return (
    <div className="flex items-center gap-2 sm:gap-3">
      <LangSwitcher lang={lang} setLang={setLang} />
      <MobileLangSwitcher lang={lang} setLang={setLang} />
      <div className="hidden md:block">
        <button
          onClick={onBook}
          className="btn-primary whitespace-nowrap"
          style={{ padding: "10px 20px", fontSize: "14px" }}
          data-testid="header-book-btn"
        >
          {t.nav.bookNow}
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>
      <a
        href={`tel:${COMPANY.phoneIntl}`}
        className="md:hidden w-11 h-11 rounded-full bg-[var(--accent)] text-white flex items-center justify-center shadow-md"
        aria-label={`Hívás: ${COMPANY.phone}`}
        data-testid="header-call-btn"
      >
        <Phone className="w-5 h-5" />
      </a>
      <button
        onClick={toggleMenu}
        className="lg:hidden w-11 h-11 flex items-center justify-center rounded-lg hover:bg-[var(--bg)]"
        data-testid="mobile-menu-toggle"
        aria-label="Menu"
      >
        {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </button>
    </div>
  );
}
